import Vue from 'vue'
import Router from 'vue-router'
// import store from '@/store'
import Home from '@/views/Home'
import Watch from '@/views/Watch'
import Cast from '@/views/Cast'
import Studio from '@/views/Studio'
import AssistBoard from '@/views/AssistBoard'
import Quiz from '@/views/Quiz'
import ChatOption from '@/views/ChatOption'
import Chat from '@/views/Chat'

import { logService } from '@/services/api'
import firebase from '@/vendor/firebase'

Vue.use(Router)

const routes = [
  { name: 'home', path: '/', component: Home },
  { name: 'studio', path: '/studio/:mode/:rid', component: Studio },
  { name: 'assistBoard', path: '/assist-board/:mode/:rid', component: AssistBoard },
  { name: 'cast', path: '/cast', component: Cast },
  { name: 'watch', path: '/watch/:mode/:rid', component: Watch },
  { name: 'quiz', path: '/quiz', component: Quiz },
  { name: 'chatOption', path: '/chatOption/:mode', component: ChatOption },
  { name: 'chat', path: '/chat/:mode/:rid', component: Chat }
]

const router = new Router({
  routes,
  // mode: 'history',
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

// FIXME: call stack overflow why?
router.beforeEach(async (to, from, next) => {
  next()
  await logService({
    method: 'POST',
    body: JSON.stringify({
      location: to.path, account: firebase.auth().currentUser ? firebase.auth().currentUser.email : 'no email'
    }),
    isAdminLog: true
  })
})

export default router
